// [devcontrol-004] SEMÁFORO TEMPORAL DE MIGRACIÓN — se retirará cuando todos los eventos
// entren libremente en el árbol nuevo. Guía de desmontaje en CLAUDE.md ("Semáforo devControl").
//
// Bypass del flag en DESARROLLO — mismo criterio que el resto de utilidades solo-dev del
// repo (p. ej. FormDebugPanel): `process.env.NODE_ENV === 'development'`. Con `npm run dev`
// el flag se considera SIEMPRE activo: cualquier evento navega por el árbol nuevo /site|/event
// sin tener que añadirlo al doc 004 de Cosmos. En builds de producción/QA manda el flag real.
//
// Consumidores: gate del layout del evento, EventCard (ficha), EventService.isEventOnNewFlow
// (dashboard + fallbacks) y eventCanonicalAlternates.
export function isDevControlBypassed(): boolean {
  return process.env.NODE_ENV === 'development';
}
